









import { Component, Vue } from 'vue-property-decorator';

import PerformanceActivitiesService from '@/api/PerformanceActivitiesService';

import WalletSecondary, {
  CardsSecondaryWallet
} from '@/componentsV2/molecules/WalletSecondary/WalletSecondary.vue';

import { abbreviateNumber } from '@/utils/currency';
import flagKeys from '@/constants/flagKeys';

@Component({
  components: {
    WalletSecondary
  }
})
export default class ActivitiesTotalSpend extends Vue {
  performanceActivitiesService: PerformanceActivitiesService = new PerformanceActivitiesService();

  cards: Record<string, CardsSecondaryWallet> = this.cachedCards || {
    revenue: {
      counter: '0',
      label: '',
      fractionDigits: 2,
      tooltipText: '',
      periodLabel: '--'
    },
    lastMonthRevenue: {
      counter: '0',
      label: '',
      fractionDigits: 2,
      periodLabel: '--'
    },
    thisMonthRevenue: {
      counter: '0',
      label: '',
      fractionDigits: 2,
      periodLabel: '--'
    }
  };

  get activityState() {
    return this.$store.getters['performance/getActivityState'];
  }

  get cachedCards() {
    return this.activityState.customersSpend;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get tPrefix() {
    return `performance.activities.totalSpend`;
  }

  get translatedCards() {
    const cardsTranslated = Object.entries(this.cards).map(([key, value]) => ({
      ...value,
      label: String(this.$t(`${this.tPrefix}.cards.${key}.label`)),
      tooltipText:
        String(this.$t(`${this.tPrefix}.cards.${key}.tooltipText`)) || null
    }));
    return Object.values(cardsTranslated);
  }

  async getCustomerTotalSpend() {
    if (!this.cachedCards) {
      this.$showLoaderWithLocker();
    }

    const response = await this.performanceActivitiesService.getCustomerTotalSpend();
    this.$hideLoader();
    if (response.status !== 200) return;

    const {
      revenue,
      lastMonthRevenue,
      thisMonthRevenue,
      revenueSince,
      thisMonthRevenueSince,
      lastMonthRevenueSince
    } = response.data;
    this.cards.revenue.counter = String(revenue);
    this.cards.revenue.periodLabel = `Since ${revenueSince}`;
    this.cards.lastMonthRevenue.counter = String(lastMonthRevenue);
    this.cards.lastMonthRevenue.periodLabel = lastMonthRevenueSince;
    this.cards.thisMonthRevenue.counter = String(thisMonthRevenue);
    this.cards.thisMonthRevenue.periodLabel = thisMonthRevenueSince;

    this.formatWalletValues();

    this.$store.dispatch(
      'performance/SET_ACTIVITY_CUSTOMERS_SPEND',
      this.cards
    );
  }

  mounted() {
    setTimeout(() => this.getCustomerTotalSpend(), 0);
  }

  get currencySymbol() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }

  formatWalletValues() {
    const walletKeys = Object.keys(this.cards);
    for (const key of walletKeys) {
      this.cards[key].prefixSymbol = this.currencySymbol;

      this.cards[key].counter =
        abbreviateNumber(
          Number(this.cards[key].counter),
          this.cards[key].fractionDigits
        ) || '0';
    }
  }
}
